import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const PAYMENT_TYPES_PAYMENT_TYPE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/payment-types',
        iconClass: 'fas fa-fa-credit-card-alt',
        name: '::Menu:PaymentTypes',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.PaymentTypes',
      },
    ]);
  };
}
